import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { hasPermission } from '@pec/aion-ui-core/actions/userInfo';
import { useTypedSelector } from '../app/reducer';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';

const { Manage, Write, Read } = ActivityAction;
const { Organizations } = ActivityResourceName;
const { GlobalWorkerPass } = OrganizationFeature;

export function usePermission() {
  const { userInfo, isFetching } = useTypedSelector(state => state.userInfo) || {};
  const { userOrganizations } = useTypedSelector(state => state.userOrganizations) || {};

  const hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    userInfo ? hasPermission(userInfo, action, resourceName) : false;

  const currentUserOrganization = userOrganizations?.find(
    userOrganization => userOrganization.id === userInfo?.primaryOrganizationId
  );

  const organizationId = userInfo?.primaryOrganizationId;

  const hasOrganizationPermission = (action: ActivityAction, resourceName: ActivityResourceName) => {
    return organizationId
      ? hasPermission(userInfo, action, resourceName, [
          {
            type: UserInfoActivitiesType.Organization,
            id: organizationId
          }
        ])
      : false;
  };

  const shouldShowWPLink =
    !(
      hasOrganizationPermission(Manage, Organizations) ||
      hasOrganizationPermission(Write, Organizations) ||
      hasOrganizationPermission(Read, Organizations)
    ) ||
    hasGlobalPermission(Manage, Organizations) ||
    (currentUserOrganization?.features?.includes(GlobalWorkerPass) ?? false);

  return {
    hasGlobalPermission,
    shouldShowWPLink,
    isFetching
  };
}
